var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 120 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "icon_svg__defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_svg__g969",
    transform: "translate(-1.317)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-186.262 -7.023) scale(.92419)",
    id: "icon_svg__g951"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.56 16.35s5.15 8.3 6.88 11.25a.13.13 0 010 .15.13.13 0 01-.18 0l-8.88-9.29z",
    transform: "translate(-.03 .01)",
    id: "icon_svg__path88",
    fill: "#f05a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.37 46.61a30.61 30.61 0 016.06-8.61 31 31 0 013-2.66v6.57zm-5.25 6.07l14.33-7.3v16.68l3.23 4.24V43.72l2-1a9.72 9.72 0 002.67-15.38l-7.4-7.71a1.64 1.64 0 01.08-2.3 1.65 1.65 0 012.32.08l1 1.08 2.21-2.12c-2.61-3.39-5.81-3-7.67-1.27a4.7 4.7 0 00-.2 6.64l7.44 7.75a6.65 6.65 0 01-1.44 10.26l-1 .52V29.73a33.74 33.74 0 00-17.56 22.95",
    id: "icon_svg__path90",
    transform: "translate(-.03 .01)",
    fill: "#010000"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.016 70.734) scale(.75417)",
    id: "icon_svg__g958"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.863-66.937h6.15l6.7 10.8 6.7-10.8h6.1v25.6h-5.6v-16.7l-7.2 11h-.1l-7.2-10.9v16.6h-5.5z",
    id: "icon_svg__path10-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.163-66.937h5.6v25.6h-5.6z",
    id: "icon_svg__path12-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.163-66.937h5.2l12 15.8v-15.8h5.65v25.6h-4.8l-12.4-16.3v16.3h-5.6z",
    id: "icon_svg__path14-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.363-66.937h5.7v25.6h-5.6z",
    id: "icon_svg__path16-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.013-40.837a14.51 14.51 0 01-5.5-1 13.89 13.89 0 01-4.3-2.8 11.91 11.91 0 01-2.8-4.2 12.88 12.88 0 01-1-5.1 12.88 12.88 0 011-5.1 13.19 13.19 0 017.2-7.1 14.67 14.67 0 0110.9 0 13.89 13.89 0 014.3 2.8 11.91 11.91 0 012.8 4.2 12.88 12.88 0 011 5.1 12.88 12.88 0 01-1 5.1 13.19 13.19 0 01-7.2 7.1 14.36 14.36 0 01-5.4 1zm.1-5.2a8.15 8.15 0 003.1-.6 8.07 8.07 0 002.4-1.7 8.15 8.15 0 002.2-5.6 7.54 7.54 0 00-.7-3.3 7.53 7.53 0 00-4.1-4.3 8.31 8.31 0 00-6.2 0 8.07 8.07 0 00-2.4 1.7 8.15 8.15 0 00-2.2 5.6 8.15 8.15 0 00.6 3.1 7.53 7.53 0 004.1 4.3 6.9 6.9 0 003.2.8z",
    id: "icon_svg__path18-1"
  })))));
}

export default SvgIcon;